import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_blue_header/reservation-confirmation/$reservationId')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/confirmation-reservation/$reservationId', params, replace: true })
  },
})
